export default "__VITE_ASSET__B60K5Bx0__"